<template>
  <v-card no-body class="mb-3">
    <v-card-title class="customer-card-header">
      {{ reportData.name }} -&nbsp;
      <span class="font-weight-normal">
        <multi-time-display :time="startDate" time-format="ll" class="d-inline"/>
        {{ $t('to') }}
        <multi-time-display :time="endDate" time-format="ll" class="d-inline"/>
      </span>
    </v-card-title>
    <v-card-text>
      <c3-chart :height="325" :data="chartData" :config="chartConfig" type='area' />
    </v-card-text>
  </v-card>
</template>

<script>
import Moment from 'moment-timezone'
import { map, max, min, round, some } from 'lodash'
import C3Chart from '@/components/shared/chart/C3Chart'
import MultiTimeDisplay from '@/components/shared/MultiTimeDisplay'

export default {
  name: 'RootCauseAnalysisHistoryReportCard',
  components: {
    C3Chart,
    MultiTimeDisplay
  },
  props: {
    reportData: {
      type: Object
    },
    startDate: {
      type: String
    },
    endDate: {
      type: String
    }
  },
  computed: {
    chartData () {
      const dateColumn = map(this.reportData.data, x => x.date)
      dateColumn.unshift('date')
      const assessedColumn = map(this.reportData.data, x => x.percent_assessed)
      assessedColumn.unshift('percent_assessed')
      return {
        x: 'date',
        columns: [
          dateColumn,
          assessedColumn
        ],
        names: {
          percent_assessed: this.$t('performance_dashboard_ui.root_causes_completed')
        }
      }
    },
    /**
     * Set the range for the chart. If any values fall below 60, show the full range, otherwise truncate to 60.
     * @returns {number[]}
     */
    rangeValues () {
      if (some(this.chartData.columns[1], x => x != null && x < 60)) {
        return [0, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100]
      } else {
        return [60, 70, 80, 90, 100]
      }
    },
    /**
     * The chart config.
     */
    chartConfig () {
      return {
        axis: {
          x: {
            label: {
              text: this.$t('date')
            },
            type: 'timeseries',
            tick: {
              format: '%Y-%m-%d',
              centered: true,
              culling: true
            }
          },
          y: {
            label: {
              text: this.$t('percentage')
            },
            tick: {
              values: this.rangeValues,
              format: function (d) {
                return round(d, 1) + '%'
              },
              culling: true
            },
            min: min(this.rangeValues),
            max: max(this.rangeValues)
          }
        },
        line: {
          connectNull: true
        }
      }
    }
  },
  methods: {
    formatHeaderDate (date) {
      // parseZone keeps the offset the report was generated with, so the header always matches the range that was
      // selected in the form (and queried on the back end) rather than shifting with the viewer's browser timezone.
      return Moment.parseZone(date).format('ll')
    }
  }
}
</script>

<style scoped>
.customer-card-header {
  font-weight: bold;
  font-size: 1.1rem;
}
</style>
